var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8536 0.146396C11.7598 0.0526586 11.6327 0 11.5001 0C11.3675 0 11.2404 0.0526586 11.1466 0.146396L6 5.29299L0.853408 0.146396C0.759643 0.0526586 0.632487 0 0.499902 0C0.367318 0 0.240161 0.0526586 0.146396 0.146396C0.0526586 0.240161 0 0.367318 0 0.499902C0 0.632487 0.0526586 0.759643 0.146396 0.853408L5.29299 6L0.146396 11.1466C0.0526586 11.2404 0 11.3675 0 11.5001C0 11.6327 0.0526586 11.7598 0.146396 11.8536C0.240161 11.9473 0.367318 12 0.499902 12C0.632487 12 0.759643 11.9473 0.853408 11.8536L6 6.70701L11.1466 11.8536C11.2404 11.9473 11.3675 12 11.5001 12C11.6327 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6327 12 11.5001C12 11.3675 11.9473 11.2404 11.8536 11.1466L6.70701 6L11.8536 0.853408C11.9473 0.759643 12 0.632487 12 0.499902C12 0.367318 11.9473 0.240161 11.8536 0.146396Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.08a5b62c9230dd96dfe285ab3834ce95.svg";
export { ForwardRef as ReactComponent };